import { render } from "./VTreatmentDaysAndShifts.vue?vue&type=template&id=44e2cfd4"
import script from "./VTreatmentDaysAndShifts.vue?vue&type=script&lang=js"
export * from "./VTreatmentDaysAndShifts.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/common/components/booking/VTreatmentDaysAndShifts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44e2cfd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44e2cfd4', __exports__)) {
    api.reload('44e2cfd4', __exports__)
  }
  
  module.hot.accept("./VTreatmentDaysAndShifts.vue?vue&type=template&id=44e2cfd4", () => {
    api.rerender('44e2cfd4', render)
  })

}


export default __exports__